import { CSSObject } from '@emotion/react'
import { colors } from '@opallabs/spectrum'

const footerWrapper: CSSObject = {
  marginTop: '-2px',
  zIndex: 10000,
  display: 'block',
}

const assetStyles = (notCropped: boolean, height: number): CSSObject => ({
  width: '375px',
  height: notCropped ? `${height}px` : '375px',
  backgroundColor: colors.n8.base,
  'img, video': {
    width: '375px',
    height: notCropped ? `${height}px` : '375px',
  },
})

const styles = {
  assetStyles,
  footerWrapper,
}

export { styles }
